export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="42" viewBox="0 0 40 42" fill="none">
            <rect x="1.5" y="15.0386" width="37" height="25.4615" rx="2.03845" stroke="black" strokeWidth="3" />
            <path d="M9 13.5385V13.3514C9 7.08217 14.0822 2 20.3513 2V2C26.6205 2 31.7027 7.08217 31.7027 13.3514V13.5385" stroke="black" strokeWidth="3" />
            <circle cx="20" cy="25.731" r="3" stroke="black" strokeWidth="3" />
            <path
                d="M18.5 35.3077C18.5 36.1361 19.1716 36.8077 20 36.8077C20.8284 36.8077 21.5 36.1361 21.5 35.3077H18.5ZM18.5 29.1538V35.3077H21.5V29.1538H18.5Z"
                fill="black"
            />
        </svg>
    );
}
